import { FC } from 'react'
import { Tooltip as MuiTooltip } from '@mui/material'
import theme from 'theme'

/* Components */
import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: theme.attributes.borderRadius.tertiary,
    background: theme.colors.primaryLight,
    boxShadow: '0 4px 8px 0 rgba(30, 26, 29, 0.20)',
    width: '353px',
    padding: `${theme.spacing.md}px`,

    '.tooltip-wrapper': {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: `${theme.spacing.xSmall}px`,
      width: '100%',

      '.tooltip-item': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',

        '.MuiTypography-root': {
          color: theme.colors.neutral,
          fontFamily: theme.typography.fontFamily.primary,
          fontSize: theme.typography.fontSize.medium,
          fontStyle: 'normal',
          fontWeight: theme.typography.fontWeight.extraThick,
          lineHeight: '140%',

          '& .current-year-text': {
            color: theme.baseColors.greyscale[80],
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize.medium,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: '140%',
            marginLeft: `${theme.spacing.xSmall}px`
          }
        }
      }
    }
  }
})

interface Props extends TooltipProps {
  title: string
}

const SSMLicenseDetailsTooltip: FC<Props> = ({ title, ...rest }) => (
  <Tooltip title={title} {...rest}>
    {rest.children}
  </Tooltip>
)

export default SSMLicenseDetailsTooltip
